<template>
  <login-bg>
    <login-form />
  </login-bg>
</template>

<script>

// import md5 from 'js-md5'
// import {reg, checkReg} from '@/utils/RegExp'
import loginBg from './components/bg'
import loginForm from './components/loginFrom'
export default {
  name: 'Login',
  components:{
    loginBg,
    loginForm
  },

}
</script>


